import { API_ADMIN_CERTIFICATES } from 'constants/api-v2'
import type QueryClient from 'services/query'

interface LoaderParams {
  params: {
    idCertificate: string
    idAccreditation: string
  }
}

export const loadAdminCertificate =
  (client: QueryClient) =>
  async ({ params }: LoaderParams) => {
    const { idCertificate = '' } = params

    let certificate

    try {
      certificate = await client.get(`${API_ADMIN_CERTIFICATES}/${idCertificate}`)
    } catch (e: any) {
      if (e.response.status === 404) {
        throw new Response('', { status: 404 })
      }
    }

    return { certificate }
  }
